<template>
  <span
    class="page-tag-item"
    :class="{ activeTagItem: ifActive }"
    title="双击关闭窗口, 右键固定菜单"
    @mousedown="handleTagMouseDown"
    @contextmenu.prevent="rightClick"
    @mouseenter="ifHover = true"
    @mouseleave="ifHover = false"
    @dblclick="handleDbClick"
  >
    <!-- title -->
    <span v-if="tag.title">{{ tag.title }}</span>
    <i v-else class="el-icon-loading"></i>

    <!-- 按钮容器 -->
    <span class="icon-box" @mousedown.stop>
      <!-- 关闭按钮 -->
      <IconHc
        v-if="closeIconVisible"
        style="font-weight: 400"
        class="icon-box--close"
        type="icon-guanbi"
        size="12px"
        @click.native="handleTagClose"
      ></IconHc>

      <!-- 固定按钮 -->
      <!-- <i class="icon-pin" v-if="pinIconVisible" @click="handleCancelPin"></i> -->
      <SvgIconHover
        title="固定"
        v-if="pinIconVisible"
        style="font-size: 16px"
        svgIconClass="icon-fix"
        svgIconClassHover="icon-fix-hover"
        @click.native="handleCancelPin"
      ></SvgIconHover>
    </span>

    <!-- 上下文菜单 -->
    <div class="menu-wrap"
      v-show="contextMenuVisible"
      @mousedown.stop
    >
      <div
        class="menu-item"
        v-for="(menu, index) in contextMenuOptions"
        :key="index"
        @click.stop="handleContextMenuItem(menu, tag)"
      >
        {{ menu.name }}
      </div>
    </div>
  </span>
</template>

<script>
import SvgIconHover from '@/components/SvgIconHover'
export default {
  components: {
    SvgIconHover,
  },
  props: {
    tag: {
      type: Object,
      default() {
        return {}
      }
    },
    ifActive: {
      type: Boolean,
      default: false,
    },
    tagIdContextMenuVisible: {
      type: [String, Number],
      default: '',
    },
  },
  emits: [
    'setActive',
    'refresh',
    'pin',
    'cancelPin',
    'close',
    'closeOther',
  ],
  data() {
    return {
      ifHover: false,
    }
  },
  computed: {
    closeIconVisible() {
      const globalVisible = this.tag.closeable // 这个是首页
      const localVisible = this.ifHover || this.ifActive
      return globalVisible && localVisible && !this.pinIconVisible
    },
    pinIconVisible() {
      const globalVisible = this.tag.closeable // 这个是首页
      const localVisible = this.tag.isPin
      return globalVisible && localVisible
    },
    contextMenuOptions() {
      const defaultOptions = [
        {
          type: 'refresh',
          name: '刷新当前页面'
        },
      ]

      if (this.tag.closeable) {
        if (!this.tag.isPin) {
          defaultOptions.push({
            type: 'pin',
            name: '固定当前页面'
          })
        } else {
          defaultOptions.push({
            type: 'cancelPin',
            name: '取消固定当前页面'
          })
        }
      }

      if (!this.tag.isPin) {
        defaultOptions.push({
          type: 'closeOther',
          name: '关闭其他页面'
        })
      }

      if (this.tag.closeable) {
        defaultOptions.push({
          type: 'close',
          name: '关闭当前页面'
        })
      }

      return defaultOptions
    },
    contextMenuVisible: {
      get() {
        return this.tagIdContextMenuVisible === this.tag.id
      },
      set(val) {
        this.$emit('update:tagIdContextMenuVisible', val ? this.tag.id : '')
      }
    },
  },
  methods: {
    handleTagMouseDown(e) {
      if (e.button === 0 || e.button === 1) {
        // 点击的左键, 尝试把当前 tag -> activeTag
        this.$emit('setActive', this.tag)
      }
    },
    handleDbClick() {
      if (!this.tag.closeable) {
        throw new Error(`这个 tag 不允许删除 title: ${this.tag.title}`)
      }

      this.handleTagClose()
    },
    handleTagClose() {
      this.$emit('close', this.tag)
    },
    handleCancelPin() {
      this.$emit('cancelPin', this.tag)
    },
    // 右键
    rightClick(tag) {
      this.contextMenuVisible = true
    },
    handleContextMenuItem(menu, tag) {
      const { type } = menu
      this.contextMenuVisible = false
      switch (type) {
        case 'refresh':
        case 'pin':
        case 'cancelPin':
        case 'close':
        case 'closeOther':
          this.$emit(type, tag)
          break
        default:
          break
      }
    },
    documentClickHandler() {
      this.contextMenuVisible = false
    },
  },
  mounted() {
    window.document.addEventListener('click', this.documentClickHandler)
  },
  destroyed() {
    window.document.removeEventListener('click', this.documentClickHandler)
  },
}
</script>

<style lang="scss" scoped>

.page-tag-item {
  position: relative;
  display: inline-block;
  height: 30px;
  font-size: 12px;
  font-weight: 400;
  padding-left: 10px;
  padding-right: 38px;
  color: #C7CBCF;
  cursor: pointer;

  &::after {
    content: '';
    display: block;
    width: 1px;
    height: 14px;
    background: #616366;
    position: absolute;
    right: 0;
    top: 10px;
  }
}
.activeTagItem {
  background: #FFFFFF;
  border-radius: 4px 4px 0px 0px;
  color: #3B6CFF;
  margin-left: -1px;
  font-weight: 600;
  &::after {
    width: 0;
  }
}
.menu-wrap {
  position: absolute;
  top: 40px;
  left: 20px;
  background: #FFFFFF;
  z-index: 100;
  width: 140px;
  background: #FFFFFF;
  box-shadow: 0px 4px 8px 2px rgba(0,0,0,0.1);
  padding: 4px 0;
}
.menu-item {
  height: 32px;
  font-weight: 400;
  padding-left: 12px;
  color: $G9;
  font-size: 12px;
  &:hover {
    background: rgba(59,108,255,0.05);
    color: #3B6CFF;
  }
}
.menu-wrap-more {
  left: -60px;
  width: 160px;
  max-height: 260px;
  overflow: auto;
}

.icon-box {
  position: absolute; right: 8px;

  .icon-box--close {
    color: $G7;

    &:hover {
      color: $B6;
    }
  }
}

.icon-pin {
  display: inline-block;
  width: 12px;
  height: 12px;
  background-image: url('@/assets/images/Table/guding2.png');
  background-size: 16px;
  background-position: center center;
}

.icon-pin--cancel {
  display: inline-block;
  width: 12px;
  height: 12px;
  background-image: url('@/assets/images/Table/guding1.png');
  background-size: 16px;
  background-position: center center;
}

</style>
